// extracted by mini-css-extract-plugin
module.exports = {"feedbackSuccessPage":"styles_feedbackSuccessPage__3gwCv"};